<template>
  <custom-dialog
    :widthDialog="'800px'"
    :classDialog="'create-dialog custome-dialog'"
    :offsetTop="'3vh'"
    :openDialog="isOpen"
    @closeDialog="$emit('closeDialog')"
    @closed="$emit('dialogClosed')"
  >
    <template #header>
      <h5 class="dialogTitle margin-left-10">
        {{ pageTitle }}
      </h5>
    </template>

    <template #body>
      <el-form
        :model="form"
        :rules="rules"
        ref="form"
        label-position="left"
        label-width="150px"
      >
        <el-row :gutter="24">
          <el-col :span="12" v-if="isRequester">
            <el-form-item label="Loại yêu cầu" prop="requestType">
              <el-select
                class="input-border__bottom input-border__radius__0 style-fullWidth"
                v-model="form.requestType"
                placeholder="Loại yêu cầu"
                size="medium"
                filterable
                clearable
              >
                <el-option
                  v-for="item in requestTypes"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="24" v-if="isRequester">
            <el-form-item label="Tiêu đề" prop="title">
              <el-input
                type="textarea"
                v-model="form.title"
                placeholder="Tiêu đề"
                class="input-border__bottom input-border__radius__0 style-fullWidth"
                size="medium"
                maxlength="500"
                show-word-limit
                :autosize="{ minRows: 2, maxRows: 5 }"
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="24" v-if="isRequester">
            <el-form-item label="Nội dung yêu cầu" prop="title">
              <el-input
                type="textarea"
                v-model="form.content"
                placeholder="Nội dung yêu cầu"
                class="input-border__bottom input-border__radius__0 style-fullWidth"
                size="medium"
                maxlength="2000"
                show-word-limit
                :autosize="{ minRows: 3, maxRows: 5 }"
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="Số người đi" prop="numberOfPeople">
              <el-input-number
                size="medium"
                class="style-fullWidth input-border__bottom input-border__radius__0"
                v-model="form.numberOfPeople"
                placeholder="Số người đi"
                :controls="false"
                :min="0"
                :step="1"
                :precision="0"
                :max="100"
              >
              </el-input-number>
            </el-form-item>
          </el-col>

          <el-col :span="12" v-if="isRequester">
            <el-form-item label="Số điện thoại liên hệ" prop="contactNumber">
              <el-input
                class="input-border__bottom input-border__radius__0 style-fullWidth"
                v-model="form.contactNumber"
                size="medium"
                placeholder="Số điện thoại liên hệ"
                @change="contactNumberChanged"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item label="Địa điểm đi" prop="fromPlace">
              <el-input
                v-model="form.fromPlace"
                placeholder="Địa điểm đi"
                type="textarea"
                class="input-border__bottom input-border__radius__0 style-fullWidth"
                size="medium"
                maxlength="1000"
                show-word-limit
                :autosize="{ minRows: 3, maxRows: 5 }"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item label="Địa điểm đến" prop="toPlace">
              <el-input
                placeholder="Địa điểm đến"
                v-model="form.toPlace"
                type="textarea"
                class="input-border__bottom input-border__radius__0 style-fullWidth"
                size="medium"
                maxlength="1000"
                show-word-limit
                :autosize="{ minRows: 3, maxRows: 5 }"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="Thời gian đi" prop="startTime">
              <el-date-picker
                v-model="form.startTime"
                size="medium"
                class="input-border__bottom input-border__radius__0 style-fullWidth"
                type="datetime"
                placeholder="dd/MM/yyyy HH:mm"
                format="dd/MM/yyyy HH:mm"
                :prefix-icon="' '"
                @change="startTimeChanged"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <!--        </el-row>-->

          <!--        <el-row :gutter="24">-->
          <el-col :span="12">
            <el-form-item label="Thời gian về" prop="endTime">
              <el-date-picker
                v-model="form.endTime"
                size="medium"
                class="input-border__bottom input-border__radius__0 style-fullWidth"
                type="datetime"
                placeholder="dd/MM/yyyy HH:mm"
                format="dd/MM/yyyy HH:mm"
                :prefix-icon="' '"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="24" class="margin-top-10 margin-bottom-10">
          <el-col :span="24">
            <hc-dieuxe-cars-and-drivers
              ref="hcDieuXeCarsAndDrivers"
              v-if="!!hcCaseDieuXe"
              :deptId="hcCaseDieuXe.parentDeptId"
              :hcCaseMasterId="hcCaseDieuXe.hcCaseMasterId"
              :required="isCarsAndDriversRequired"
            ></hc-dieuxe-cars-and-drivers>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item label="Ghi chú" prop="note">
              <el-input
                type="textarea"
                v-model="form.note"
                placeholder="Ghi chú"
                class="input-border__bottom input-border__radius__0 style-fullWidth"
                size="medium"
                maxlength="1000"
                show-word-limit
                :autosize="{ minRows: 2, maxRows: 5 }"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </template>

    <template #footer>
      <div class="flex-row form-button__action flex__right">
        <el-button
          size="medium"
          type="success"
          class="addDocs  color__white bg__blue btn-none__border"
          @click="submit"
        >
          <i class="far fa-check-circle font-size__small"></i>
          &nbsp;{{ buttonTitle }}
        </el-button>
        <el-button
          type="info"
          size="medium"
          class="btn__cancel btn-none__border"
          @click="$emit('closeDialog')"
        >Bỏ qua
        </el-button>
      </div>
    </template>
  </custom-dialog>
</template>
<script>
  import constants from "../../../constants";
  import hanhChinhUtils from "../../../services/hanhChinhUtils";
  import hcCaseMasterService from "../../../services/hcCaseMasterService";
  import hcFlowInstanceService from "../../../services/hcFlowInstanceService";
  import utils from "../../../services/utils";
  import handleRequestErrorMixin from "../../handleRequestErrorMixin";
  import moment from "moment";
  import CustomDialog from "../../common/custom-dialog";
  import errorMessageFilter from "../../../filters/errorMessageFilter";
  import hcCaseDieuXeService from "../../../services/hcCaseDieuXeService";
  import HcDieuxeCarsAndDrivers from "./hc-dieuxe-cars-and-drivers";

  export default {
    name: "hc-dieuxe-update-common-dialog",
    mixins: [handleRequestErrorMixin],
    props: ["isOpen", "id", "action"],
    components: {
      HcDieuxeCarsAndDrivers,
      CustomDialog
    },
    data() {
      return {
        form: {
          requestType: null,
          title: null,
          content: null,
          numberOfPeople: null,
          contactNumber: null,
          fromPlace: null,
          toPlace: null,
          startTime: null,
          endTime: null,
          note: null
        },
        rules: {
          requestType: null,
          title: null,
          content: null,
          numberOfPeople: null,
          contactNumber: null,
          fromPlace: null,
          toPlace: null,
          startTime: null,
          endTime: null,
          note: null
        },
        hcCaseDieuXe: null,
        requestTypes: [],
        pageTitle: null,
        buttonTitle: null,
        isCarsAndDriversRequired: null,
        hcCaseMaster: null,
        hcFlowInstance: null
      };
    },

    computed: {
      isRequester() {
        return hanhChinhUtils.isRequester(this.userDeptRole, this.hcCaseDieuXe);
      },
      isApprover() {
        return (
          this.userDeptRole &&
          this.userDeptRole.roleCode === constants.ROLE.CODE.DIEU_XE.QUAN_LY_XE
        );
      },
      userDeptRole() {
        return this.$store.getters.userDeptRole;
      }
    },

    async created() {
      this.initPageTitle();
      this.initSelectOptions();
      await this.loadHcCaseDieuXe();
      await this.loadHcCaseMaster();
      await this.loadHcFlowInstance();
      this.initValidationRules();
      this.bindDataToForm(this.form);
    },

    methods: {
      loadHcFlowInstance() {
        return hcFlowInstanceService
          .findById(this.hcCaseMaster.flowInstanceId)
          .then(response => (this.hcFlowInstance = response.data));
      },

      loadHcCaseMaster() {
        return hcCaseMasterService
          .findById(this.hcCaseDieuXe.hcCaseMasterId)
          .then(response => (this.hcCaseMaster = response.data));
      },

      initPageTitle() {
        this.pageTitle =
          this.action ===
          constants.HC_STATE_TO_STATE.ACTION_CODE.DIEU_XE.PHE_DUYET
            ? "Phê duyệt yêu cầu điều xe"
            : "Cập nhật yêu cầu điều xe";
        this.buttonTitle =
          this.action ===
          constants.HC_STATE_TO_STATE.ACTION_CODE.DIEU_XE.PHE_DUYET
            ? "Phê duyệt"
            : "Cập nhật";
      },

      contactNumberChanged() {
        this.form.contactNumber = utils.standardlizePhoneNumber(
          this.form.contactNumber
        );
      },

      initSelectOptions() {
        this.requestTypes = hanhChinhUtils.buildDieuXeRequestTypeOptions();
      },

      loadHcCaseDieuXe() {
        return hcCaseDieuXeService
          .findById(this.id)
          .then(response => (this.hcCaseDieuXe = response.data));
      },

      startTimeChanged() {
        this.form.endTime = this.form.startTime
          ? new moment(this.form.startTime).add("1", "hour").toDate()
          : null;
      },

      bindDataToForm(form) {
        form.requestType = this.hcCaseDieuXe.requestType;
        form.title = this.hcCaseDieuXe.title;
        form.content = this.hcCaseDieuXe.description;
        form.contactNumber = this.hcCaseDieuXe.contactNumber;
        form.numberOfPeople = this.hcCaseDieuXe.numberOfPeople;
        form.fromPlace = this.hcCaseDieuXe.fromPlace;
        form.toPlace = this.hcCaseDieuXe.toPlace;
        form.startTime = this.hcCaseDieuXe.startTime
          ? new Date(this.hcCaseDieuXe.startTime)
          : null;
        form.endTime = this.hcCaseDieuXe.endTime
          ? new Date(this.hcCaseDieuXe.endTime)
          : null;
        form.note = this.hcCaseDieuXe.note;
      },

      initValidationRules() {
        let defaultRequiredConstrains = {
          required: true,
          message: "Trường dữ liệu bắt buộc",
          trigger: "blur"
        };
        let checkPhoneFormat = utils.buildPhoneValidationRule();

        if (this.isRequester) {
          this.rules.requestType = [defaultRequiredConstrains];
          this.rules.title = [defaultRequiredConstrains];
          this.rules.content = [defaultRequiredConstrains];
          this.rules.contactNumber = [
            defaultRequiredConstrains,
            {validator: checkPhoneFormat, trigger: "blur"}
          ];
        }
        this.rules.fromPlace = [defaultRequiredConstrains];
        this.rules.toPlace = [defaultRequiredConstrains];
        this.rules.startTime = [defaultRequiredConstrains];
        this.rules.endTime = [defaultRequiredConstrains];
        this.rules.note = [defaultRequiredConstrains];
        this.rules.numberOfPeople = [defaultRequiredConstrains];
        this.isCarsAndDriversRequired =
          this.hcFlowInstance.currentStateCode ===
          constants.HC_STATE.STATE_CODE.DIEU_XE.DA_PHE_DUYET && this.isApprover;
      },

      convertToSubmitForm() {
        let listCarIdAndDriver = this.$refs.hcDieuXeCarsAndDrivers.collectCarsAndDrivers();
        return {
          requestType: this.form.requestType,
          title: this.form.title,
          content: this.form.content,
          contactNumber: this.form.contactNumber,
          action: this.action,
          caseMasterId: this.hcCaseDieuXe.hcCaseMasterId,
          fromPlace: this.form.fromPlace,
          toPlace: this.form.toPlace,
          startTime: this.form.startTime.getTime(),
          endTime: this.form.endTime.getTime(),
          note: this.form.note,
          numberOfPeople: this.form.numberOfPeople,
          listCarIdAndDriver: listCarIdAndDriver
        };
      },

      validateForm() {
        return new Promise(resolve => {
          this.$refs.form.validate(valid => {
            if (!valid) {
              this.$message({
                message: "Có lỗi nhập liệu. Vui lòng kiểm tra lại",
                type: "error"
              });
            } else {
              resolve();
            }
          });
        });
      },

      validateCarsAndDrivers() {
        return this.$refs.hcDieuXeCarsAndDrivers.validateForm();
      },

      validateTime() {
        return new Promise(resolve => {
          let isOk = this.form.startTime.getTime() < this.form.endTime.getTime();
          if (!isOk) {
            this.$message({
              message: errorMessageFilter({
                errorCode: "hcDieuXe.invalidTimeRange"
              }),
              type: "error"
            });
          } else {
            resolve();
          }
        });
      },

      submit() {
        return this.validateForm()
          .then(() => this.validateCarsAndDrivers())
          .then(() => this.validateTime())
          .then(() => {
            let submitForm = this.convertToSubmitForm();
            this.$emit("submit", {submitForm: submitForm});
          });
      }
    }
  };
</script>



// WEBPACK FOOTER //
// src/views/adminstration/dieuxe/hc-dieuxe-update-common-dialog.vue